import { render } from "./Footer.vue?vue&type=template&id=e30cbf02"
const script = {}

import exportComponent from "C:\\Users\\HP\\Desktop\\dashboard-pro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__